import {useSelector} from "react-redux";
import {ReduxState} from "../store/types";

export const useInvoiceData = () => {


    const invoiceList = useSelector(
        (state: ReduxState) => state.billing.invoicesTab?.invoiceList,
    );
    const isLoading = useSelector(
        (state: ReduxState) => state.billing.invoicesTab?.isLoading,
    );
    const timezoneOffset = useSelector<ReduxState, number>(
        (state) => state.generic.sessionData?.tz_offset || 0,
    );
    const userDateTimeFormat = useSelector<ReduxState, string>(
        (state) =>
            state.generic.globalCustomerInfo?.customer_info?.out_date_time_format ||
            '',
    );

    const userDateFormat = useSelector<ReduxState, string>(
        (state) =>
            state.generic.globalCustomerInfo?.customer_info?.out_date_format ||
            '',
    );

    const currency = useSelector<ReduxState, string>(
        (state) =>
            state.generic.globalCustomerInfo?.customer_info?.iso_4217 || '',
    );


    return {
        invoiceList, isLoading, timezoneOffset, userDateTimeFormat, userDateFormat, currency
    }

}